import React, { useEffect, useState } from 'react';
import globalIP from '@/GlobelIP';

export default function useUser() {
const id = localStorage.getItem('id');
  const [user, setUser] = useState<any>([]);
  useEffect(() => {
    fetchDatalabel();
  }, []);
  const fetchDatalabel = async () => {
    try {
      const response = await fetch(`${globalIP}/api/user-details/${id}`);
      const json = await response.json();
      const extractedData = json.data.attributes;
      setUser(extractedData);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };
    return { user }
}